import {
    IgAccTime,
    IgAccount,
    IgComment,
    IgMedia,
    IgMediaTime,
    IgMetadataAge,
    IgMetadataColor,
    IgMetadataEmotion,
    IgMetadataGender,
    IgMetadataHashtag,
    IgMetadataLabel,
    IgUser,
} from '@core/models/ApiFields/ig-entities';
import { TimeFields } from '@core/models/ApiFields/time-fields.enums';
import { COMPONENTS_ENUM } from './page';

export const IG_ENDPOINT = '/insights/instagram';

export const fixdFields = {
    userAccBreakdowns: [
        IgAccount.getPrefixed('biography'),
        IgAccount.getPrefixed('followers'),
        IgAccount.getPrefixed('igAccount'),
        IgAccount.getPrefixed('image'),
        IgAccount.getPrefixed('mediaCount'),
        IgAccTime.getPrefixed('accountsEngaged'),
        IgAccTime.getPrefixed('comments'),
        IgAccTime.getPrefixed('commentsAd'),
        IgAccTime.getPrefixed('commentsPost'),
        IgAccTime.getPrefixed('commentsReel'),
        IgAccTime.getPrefixed('commentsStory'),
        IgAccTime.getPrefixed('followers'),
        IgAccTime.getPrefixed('followersUnknown'),
        IgAccTime.getPrefixed('impressions'),
        IgAccTime.getPrefixed('likes'),
        IgAccTime.getPrefixed('likesAd'),
        IgAccTime.getPrefixed('likesPost'),
        IgAccTime.getPrefixed('likesReel'),
        IgAccTime.getPrefixed('likesStory'),
        IgAccTime.getPrefixed('profileActivity'),
        IgAccTime.getPrefixed('profileViews'),
        IgAccTime.getPrefixed('reach'),
        IgAccTime.getPrefixed('reachAd'),
        IgAccTime.getPrefixed('reachFollowerPercentage'),
        IgAccTime.getPrefixed('reachNonFollowerPercentage'),
        IgAccTime.getPrefixed('reachPost'),
        IgAccTime.getPrefixed('reachReel'),
        IgAccTime.getPrefixed('reachStory'),
        IgAccTime.getPrefixed('reachUnknownPercentage'),
        IgAccTime.getPrefixed('saves'),
        IgAccTime.getPrefixed('savesAd'),
        IgAccTime.getPrefixed('savesPost'),
        IgAccTime.getPrefixed('savesReel'),
        IgAccTime.getPrefixed('savesStory'),
        IgAccTime.getPrefixed('shares'),
        IgAccTime.getPrefixed('sharesAd'),
        IgAccTime.getPrefixed('sharesPost'),
        IgAccTime.getPrefixed('sharesReel'),
        IgAccTime.getPrefixed('sharesStory'),
        IgAccTime.getPrefixed('totalInteractions'),
        IgAccTime.getPrefixed('totalInteractionsAd'),
        IgAccTime.getPrefixed('totalInteractionsPost'),
        IgAccTime.getPrefixed('totalInteractionsReel'),
        IgAccTime.getPrefixed('totalInteractionsStory'),
        IgAccTime.getPrefixed('unfollowers'),
        IgAccTime.getPrefixed('websiteClicks'),
    ],
    userAccFields: [
        IgMedia.getPrefixed('mediaType'),
        IgMedia.getPrefixed('followers'),
        IgMedia.getPrefixed('profileViews'),
    ],
    competitorAcc: [
        IgAccount.getPrefixed('igAccount'),
        IgAccount.getPrefixed('image'),
        IgAccount.getPrefixed('followers'),
        IgMedia.getPrefixed('mediaCount'),
        IgMedia.getPrefixed('likes'),
        IgMedia.getPrefixed('comments'),
        IgMedia.getPrefixed('engagementRate'),
    ],
    [COMPONENTS_ENUM.POSTS]: [
        TimeFields.date,
        IgAccount.getPrefixed('igAccount'),
        IgAccount.getPrefixed('image'),
        IgMedia.getPrefixed('avgWatchTime'),
        IgMedia.getPrefixed('caption'),
        IgMedia.getPrefixed('comments'),
        IgMedia.getPrefixed('commentsNegativity'),
        IgMedia.getPrefixed('commentsPositivity'),
        IgMedia.getPrefixed('contentType'),
        IgMedia.getPrefixed('publishDate'),
        IgMedia.getPrefixed('engagementRate'),
        IgMedia.getPrefixed('followers'),
        IgMedia.getPrefixed('resources'),
        IgMedia.getPrefixed('impressions'),
        IgMedia.getPrefixed('interactions'),
        IgMedia.getPrefixed('likes'),
        IgMedia.getPrefixed('mediaId'),
        IgMedia.getPrefixed('mediaType'),
        IgMedia.getPrefixed('navigation'),
        IgMedia.getPrefixed('navigationSwipeBack'),
        IgMedia.getPrefixed('navigationTapBack'),
        IgMedia.getPrefixed('navigationTapExit'),
        IgMedia.getPrefixed('navigationTapForward'),
        IgMedia.getPrefixed('negativeComments'),
        IgMedia.getPrefixed('permalink'),
        IgMedia.getPrefixed('plays'),
        IgMedia.getPrefixed('positiveComments'),
        IgMedia.getPrefixed('profileActivity'),
        IgMedia.getPrefixed('profileActivityBio'),
        IgMedia.getPrefixed('profileActivityCall'),
        IgMedia.getPrefixed('profileActivityDirection'),
        IgMedia.getPrefixed('profileActivityEmail'),
        IgMedia.getPrefixed('profileActivityOther'),
        IgMedia.getPrefixed('profileActivityText'),
        IgMedia.getPrefixed('profileViews'),
        IgMedia.getPrefixed('reach'),
        IgMedia.getPrefixed('saves'),
        IgMedia.getPrefixed('username'),
        IgMedia.getPrefixed('viewTotalTime'),
    ],
};

export const insightsTableFields = {
    igAccount: [IgAccount.getPrefixed('igAccount'), IgAccount.getPrefixed('image')],
    igAccTime: [
        IgAccTime.getPrefixed('accountsEngaged'),
        IgAccTime.getPrefixed('followers'),
        IgAccTime.getPrefixed('followersUnknown'),
        IgAccTime.getPrefixed('follows'),
        IgAccTime.getPrefixed('profileViews'),
        IgAccTime.getPrefixed('reachFollower'),
        IgAccTime.getPrefixed('reachFollowerPercentage'),
        IgAccTime.getPrefixed('reachNonFollower'),
        IgAccTime.getPrefixed('reachNonFollowerPercentage'),
        IgAccTime.getPrefixed('reachUnknown'),
        IgAccTime.getPrefixed('reachUnknownPercentage'),
        IgAccTime.getPrefixed('unfollowers'),
        IgAccTime.getPrefixed('websiteClicks'),
        IgAccTime.getPrefixed('profileActivity'),
        IgAccTime.getPrefixed('profileActivityBookNow'),
        IgAccTime.getPrefixed('profileActivityCall'),
        IgAccTime.getPrefixed('profileActivityDirection'),
        IgAccTime.getPrefixed('profileActivityEmail'),
        IgAccTime.getPrefixed('profileActivityInstantExperience'),
        IgAccTime.getPrefixed('profileActivityText'),
        IgAccTime.getPrefixed('profileActivityOther'),
    ],
    igMedia: [
        IgMediaTime.getPrefixed('comments'),
        IgMediaTime.getPrefixed('commentsNegativity'),
        IgMediaTime.getPrefixed('commentsPositivity'),
        IgMediaTime.getPrefixed('followers'),
        IgMediaTime.getPrefixed('impressions'),
        IgMediaTime.getPrefixed('interactions'),
        IgMediaTime.getPrefixed('likes'),
        IgMediaTime.getPrefixed('negativeComments'),
        IgMediaTime.getPrefixed('positiveComments'),
        IgMediaTime.getPrefixed('profileActivity'),
        IgMediaTime.getPrefixed('profileViews'),
        IgMediaTime.getPrefixed('reach'),
        IgMediaTime.getPrefixed('saves'),
        IgMediaTime.getPrefixed('shares'),
        IgMedia.getPrefixed('captionsNegativity'),
        IgMedia.getPrefixed('captionsPositivity'),
        IgMedia.getPrefixed('mediaCount'),
        IgMedia.getPrefixed('negativeCaptions'),
        IgMedia.getPrefixed('positiveCaptions'),
    ],
};

export const metadataFields = {
    [IgMetadataColor.prefix]: {
        fields: IgMetadataColor.getPrefixed('color'),
        sort: IgMetadataColor.getPrefixed('score') + '_desc',
        limit: 5,
    },
    [IgMetadataGender.prefix]: {
        fields:
            IgMetadataGender.getPrefixed('gender') + ',' + IgMetadataGender.getPrefixed('count'),
    },
    [IgMetadataAge.prefix]: {
        fields: IgMetadataAge.getPrefixed('age'),
    },
    [IgMetadataEmotion.prefix]: {
        fields: IgMetadataEmotion.getPrefixed('emotion'),
    },
    [IgMetadataLabel.prefix]: {
        fields: IgMetadataLabel.getPrefixed('label'),
    },
};

export const commentsFields = [
    IgComment.getPrefixed('commentId'),
    IgComment.getPrefixed('publishDate'),
    IgComment.getPrefixed('text'),
    IgComment.getPrefixed('likes'),
    IgComment.getPrefixed('replies'),
    IgComment.getPrefixed('sentiment'),
    IgComment.getPrefixed('username'),
    IgUser.getPrefixed('influencer'),
    IgUser.getPrefixed('image'),
    IgComment.getPrefixed('mediaId'),
    IgComment.getPrefixed('parentCommentId'),
];

export const postUsersParams = {
    fields: [
        IgComment.getPrefixed('commentsCount'),
        IgComment.getPrefixed('likes'),
        IgUser.getPrefixed('image'),
        IgUser.getPrefixed('influencer'),
        IgUser.getPrefixed('level'),
        IgUser.getPrefixed('username'),
    ],
    sort: [IgComment.getPrefixed('commentsCount'), IgUser.getPrefixed('followers')].map(
        f => f + '_desc'
    ),
    limit: 5,
};

export const postHashtagsFields = [IgMetadataHashtag.getPrefixed('hashtags')];
